import Head from 'next/head'
import Page from '../components/Page'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CommonHeadTags from '../components/CommonHeadTags'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from '../components/GoogleAnalytics'
import withLocale from '../translations/withLocale'
import useTranslation from '../translations/useTranslation'
import { nonEnglishLocales, localeHreflangs } from '../translations/config'

function AcousticGuitar() {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('title-acoustic-guitar')}</title>
        <meta name='description' content={t('description-acoustic-guitar')} />
        <meta httpEquiv='content-language' content='en' />
        <link
          rel='canonical'
          href='https://guitar-tuner.org/acoustic-guitar-tuning'
        />
        <link
          rel='alternate'
          hrefLang='x-default'
          href='https://guitar-tuner.org/acoustic-guitar-tuning'
        />
        <link
          rel='alternate'
          hrefLang='en'
          href='https://guitar-tuner.org/acoustic-guitar-tuning'
        />
        {nonEnglishLocales.map((locale) => (
          <link
            key={locale}
            rel='alternate'
            hrefLang={localeHreflangs[locale]}
            href={`https://guitar-tuner.org/${locale}/acoustic-guitar-tuning`}
          />
        ))}
        <CommonHeadTags
          title={t('title-acoustic-guitar')}
          description={t('description-acoustic-guitar')}
          url='https://guitar-tuner.org/acoustic-guitar-tuning'
        />
        <GoogleAnalyticsHead />
      </Head>

      <Header instrument='acoustic-guitar'/>

      <main>
        <Page
          instrument='acoustic-guitar'
          pageData='acoustic-guitar-tuning'
        />
      </main>
      <GoogleAnalyticsBody />
      <Footer />
    </>
  )
}

export default withLocale(AcousticGuitar)
